export default `<p>本页说明借贷池<strong>计息规则、结算周期与安全机制</strong>。参与前请仔细阅读并确保理解相关风险。</p>

<h2>一、计息规则</h2>
<h3>1.1 计息基数</h3>
<p>收益以用户<strong>链上授权（Approve）后的可用余额</strong>为计息基数。授权成功后，系统读取钱包中 USDT / USDC 等支持资产的授权额度与余额，作为每周期结算的参考本金。</p>

<h3>1.2 计息利率</h3>
<p>结算利率参考用户所关联借贷池的<strong>Supply APY（存款年化收益率）</strong>，并随链上市场数据同步更新。APY 由基础利率与奖励利率组成，实际结算以当周期生效费率为准。</p>

<h3>1.3 结算周期</h3>
<ul>
  <li><strong>结算频率：</strong>每日生成一次收益结算订单；</li>
  <li><strong>订单类型：</strong>日收益（可在「个人资产 → 结算订单」中查看）；</li>
  <li><strong>展示字段：</strong>结算金额、币种类型（USDT / USDC）、结算时间。</li>
</ul>
<p>单次结算金额 ≈ 授权余额 × 当期 APY ÷ 365（即按日折算）。极小金额可能因精度规则显示为 0。</p>

<h3>1.4 累计与今日收益</h3>
<p>「个人资产」页展示<strong>累计收益</strong>（历史结算总和）与<strong>今日收益</strong>（当日 0:00 至当前已结算部分）。数据以系统订单记录为准。</p>

<h2>二、授权与安全</h2>
<h3>2.1 非托管原则</h3>
<p>本服务采用<strong>非托管</strong>模式：平台不保管用户私钥、助记词或可直接动用资金的密码。所有链上授权操作须由用户在自有钱包中确认签名。</p>

<h3>2.2 授权范围</h3>
<p>加入借贷池时，用户需对指定 ERC-20 代币执行 <strong>Approve（授权）</strong>，允许协议合约在授权额度内读取或转移代币。用户应：</p>
<ul>
  <li>仅对官方界面发起的授权请求进行确认；</li>
  <li>定期在钱包中检查并撤销不再使用的授权；</li>
  <li>切勿向未知地址或钓鱼网站授权。</li>
</ul>

<h3>2.3 账户与接口安全</h3>
<ul>
  <li>客户端接口采用 Token 鉴权，敏感操作需有效登录态；</li>
  <li>全站 HTTPS 加密传输；</li>
  <li>授权记录与结算订单留痕，支持事后查询。</li>
</ul>

<h2>三、链上协议安全</h2>
<ul>
  <li>底层借贷协议基于经审计的开源智能合约，存款、借款、清算逻辑链上执行；</li>
  <li>超额抵押与清算机制用于维持系统偿付能力；</li>
  <li>池子 TVL、APY、利用率等数据来自公开数据源，与链上状态可能存在分钟级延迟。</li>
</ul>

<h2>四、用户须知</h2>
<ul>
  <li>DeFi 收益随市场波动，<strong>不保证固定收益</strong>；</li>
  <li>稳定币在极端行情下可能出现脱锚风险；</li>
  <li>网络拥堵可能导致授权或查询延迟；</li>
  <li>请勿泄露私钥、助记词或验证码；</li>
  <li>如遇可疑链接或异常授权请求，请立即停止操作并联系在线支持。</li>
</ul>

<h2>五、撤销与退出</h2>
<p>用户可随时在钱包中将代币授权额度设为 0 以<strong>撤销 Approve</strong>。撤销后不再产生新的周期收益，历史已结算订单仍可查询。撤销授权不影响链上已有资产所有权，资产仍由用户钱包地址持有。</p>

<p>— 规则如有调整，以客户端最新展示及结算订单记录为准。</p>`
